"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectableColumn = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function useSelectableColumn(_a) {
    var onSelectedRowIds = _a.onSelectedRowIds, isRowSelectable = _a.isRowSelectable, disableToggleAllSelected = _a.disableToggleAllSelected;
    return function (hooks) {
        if (!onSelectedRowIds) {
            return;
        }
        hooks.visibleColumns.push(function (columns) { return __spreadArray([
            {
                id: 'selection',
                width: 80,
                minWidth: 80,
                maxWidth: 80,
                disableResizing: true,
                disableSortBy: true,
                Header: function (_a) {
                    var getToggleAllRowsSelectedProps = _a.getToggleAllRowsSelectedProps, rowsById = _a.rowsById;
                    return !disableToggleAllSelected ? (react_1.default.createElement(core_ui_1.Flexbox, { marginLeft: "auto", paddingRight: 12 },
                        react_1.default.createElement(core_ui_1.CheckboxInput, __assign({}, getToggleAllRowsSelectedProps({
                            title: 'Select all',
                            onChange: function (e) {
                                var checked = e.target.checked;
                                if (checked) {
                                    onSelectedRowIds(Object.keys(rowsById));
                                }
                                else {
                                    onSelectedRowIds([]);
                                }
                            },
                        }))))) : null;
                },
                Cell: function (_a) {
                    var row = _a.row, state = _a.state;
                    return (react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", height: "100%", marginLeft: "auto", paddingRight: 12 },
                        react_1.default.createElement(core_ui_1.CheckboxInput, __assign({ disabled: isRowSelectable ? !isRowSelectable(row.original) : false }, row.getToggleRowSelectedProps({
                            onChange: function (e) {
                                var checked = e.target.checked;
                                var currentSelectedRowIds = Object.keys(state.selectedRowIds);
                                if (checked) {
                                    onSelectedRowIds(currentSelectedRowIds.concat(row.id));
                                }
                                else {
                                    onSelectedRowIds(currentSelectedRowIds.filter(function (rowId) { return rowId !== row.id; }));
                                }
                            },
                        })))));
                },
            }
        ], columns, true); });
        hooks.useInstanceBeforeDimensions.push(function (_a) {
            var headerGroups = _a.headerGroups;
            // fix the parent group of the selection button to not be resizable
            var selectionGroupHeader = headerGroups[0].headers[0];
            selectionGroupHeader.canResize = false;
        });
    };
}
exports.useSelectableColumn = useSelectableColumn;
